import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, BuildingIcon, BarChartIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const useCases = [{
  icon: <BriefcaseIcon className="h-10 w-10 text-brand-teal" data-id="element-264" />,
  title: 'Agencies and consultancies',
  description: 'Manage multiple clients and projects with ease. Keep deliverables organised and clients updated in real time.',
  link: '/solutions#agencies'
}, {
  icon: <BuildingIcon className="h-10 w-10 text-brand-teal" data-id="element-265" />,
  title: 'Service businesses',
  description: 'Streamline client onboarding and service delivery. Track all client communications and service milestones in one place.',
  link: '/solutions#service'
}, {
  icon: <BarChartIcon className="h-10 w-10 text-brand-teal" data-id="element-266" />,
  title: 'Internal operations teams',
  description: 'Coordinate cross-functional work and keep stakeholders informed. Create transparency and accountability across departments.',
  link: '/solutions#operations'
}];
export const UseCases = () => {
  return <section className="py-20 bg-brand-light" data-id="element-267">
      <div className="container-custom" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-269">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-270">
            Perfect for your business
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-271">
            Daily Serve adapts to how your team works, whether you're managing
            clients or internal projects.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-272">
          {useCases.map((useCase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-273">
              <div className="mb-6" data-id="element-274">{useCase.icon}</div>
              <h3 className="text-xl font-bold text-brand-blue mb-3" data-id="element-275">
                {useCase.title}
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-276">{useCase.description}</p>
              <Link to={useCase.link} className="text-brand-teal font-medium hover:text-brand-blue transition-colors duration-200 inline-flex items-center" data-id="element-277">
                Learn more
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-278">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-279" />
                </svg>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
};